export default __webpack_public_path__ + "6c480b54aa0d9715f8418b055a4969b6.ogg";